import { useLoggedViewer } from "@/api/viewer/use-viewer";
import config, { LanguageAvailaible } from "@/config";
import i18n from "i18next";
import { enUS, fr, de, es } from "date-fns/locale";

import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import initTranslations from "@babackapp/translations/init-old";
import useTranslation from "@babackapp/translations/use-translation";

const datesFnsLocales = {
  "fr-FR": fr,
  "en-US": enUS,
  "de-DE": de,
  "es-ES": es,
} as const;

export function useViewerDateFnsLocale() {
  const locale = useViewerLocale();
  // @ts-expect-error locale is a string
  return datesFnsLocales[locale] ?? enUS;
}

export function useViewerLocale() {
  const { data: viewer } = useLoggedViewer();
  return viewer?.profile?.lang ?? "fr-FR";
}

const LANGUAGES_AVAILABLE: LanguageAvailaible[] =
  config.i18n.languagesAvailable;

export function getCurrentLocale() {
  return LANGUAGES_AVAILABLE.find(
    (l) => l.code == i18n.language || l.language == i18n.language,
  );
}

export function getLocaleAvailable() {
  return LANGUAGES_AVAILABLE.filter((l) => !l.redirection);
}

export function useCurrentShopLocalesAvailables() {
  const { data: shop } = useCurrentShopSuspense();
  return shop.preferences.languages.reduce(
    (acc: LanguageAvailaible[], lang: string) => {
      const inSettings = LANGUAGES_AVAILABLE.find((l) => l.code === lang);
      if (!inSettings) return acc;
      return [...acc, inSettings];
    },
    [] as LanguageAvailaible[],
  );
}

const translationsBase = config.isProd
  ? config.url
  : `${config.url}/node_modules/@babackapp/translations`;

initTranslations(translationsBase);

/**
 * @deprecated Don't use this code @see useTranslation()
 */
export const useTranslator_deprecated = (
  ...args: Parameters<typeof useTranslation>
) => useTranslation(...args);
